import BaseDateData from '../../../BaseDateData'

export default {
  extends: BaseDateData,
  data: () => ({
    categories: Object.freeze([]),
    category: null,
    imgInfos: Object.freeze([]),
    imgSrc: null
  }),
  computed: {
    type: () => 0,
    hasCategories: () => true,
    reverseImgInfos () {
      return [...this.imgInfos].reverse()
    }
  },
  methods: {
    onCategoryChange () {
      this.getList()
    },
    setCategories (categories) {
      this.categories = Object.freeze(categories.map(category => ({
        value: category,
        label: category
      })))

      this.category = categories[0]

      setTimeout(() => {
        this.getList()
      }, 0)
    },
    setImgInfos (list) {
      const imgInfos = Object.freeze(list.map(data => ({
        value: `/report${data.path}`,
        label: new Date(data.time).format('MM/DD HH:mm')
      })))

      if (imgInfos.length > 0) {
        this.cacheImages(imgInfos, 0)
      } else {
        this.imgSrc = null
      }
    },
    cacheImages (imgInfos, index) {
      const img = new Image()
      const imgInfo = imgInfos[index++]
      let imgSrc = imgInfo.value

      img.onload = img.onerror = () => {
        if (index === 1) {
          this.imgInfos = imgInfos
          this.imgSrc = imgSrc
          imgSrc = null
        }

        if (index < imgInfos.length) {
          this.cacheImages(imgInfos, index)
        }
      }

      img.src = imgSrc
    },
    getList () {
      this.changeLoadStatus(true)
      const {query} = this

      this.$api.NMC.getDataList({
        beginTime: query.beginTime,
        endTime: query.endTime,
        type: this.type,
        category: this.category
      }).then(this.setImgInfos).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onSearchBtnClick () {
      this.getList()
    }
  },
  created () {
    if (this.hasCategories) {
      this.changeLoadStatus(true)
      this.$api.NMC.getCategories(this.type).then(this.setCategories).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    } else {
      this.getList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/03Pollution/01Meteorological/BaseNMC.js